import React from 'react';

// User product pages
export const StudentDashboardPage = React.lazy(() => import('../../pages/user/products/StudentDashboardPage'));
export const CommunityPage = React.lazy(() => import('../../pages/user/products/CommunityPage'));
export const CommunityWeeklyMeetingPage = React.lazy(() => import('../../pages/user/products/CommunityWeeklyMeetingsPage'));
export const CommunityKedMeetingRecordingsPage = React.lazy(() => import('../../pages/user/products/CommunityKedMeetingRecordingsPage'));
export const CommunityKedMeetingRecordingDetailPage = React.lazy(() => import('../../pages/user/products/CommunityKedMeetingRecordingDetailPage'));
export const CommunityIntroMeetingPage = React.lazy(() => import('../../pages/user/products/CommunityIntroMeetingPage'));
export const KedEnrollPage = React.lazy(() => import('../../pages/user/products/KedEnrollPage'));
export const PlannerPage = React.lazy(() => import('../../pages/user/products/PlannerPage'));
export const MainLearningPlanPage = React.lazy(() => import('../../pages/user/products/MainLearningPlanPage'));
export const ParentManagementPage = React.lazy(() => import('../../pages/user/products/ParentManagementPage'));
export const FlashcardsPage = React.lazy(() => import('../../pages/user/products/FlashcardsPage'));
export const LearningPlanPage = React.lazy(() => import('../../pages/user/products/LearningPlanPage'));
export const LearningPlanExercisePage = React.lazy(() => import('../../pages/user/products/LearningPlanExercisePage'));

// Exercise pages
export const ExercisesPage = React.lazy(() => import('../../pages/exercise/ExercisesPage'));
export const ExerciseViewPage = React.lazy(() => import('../../pages/exercise/ExerciseViewPage'));

// Statistics and Rankings pages
export const StatisticsPage = React.lazy(() => import('../../pages/user/statistics/StatisticsPage'));
export const RankingsPage = React.lazy(() => import('../../pages/user/rankings/RankingsPage'));
export const RankingHistoryPage = React.lazy(() => import('../../pages/user/rankings/RankingHistoryPage'));

// Learning course pages
export const LearningCourseDashboardPage = React.lazy(() => import('../../pages/user/learning-course/LearningCourseDashboardPage'));
export const ResourceCourseDashboardPage = React.lazy(() => import('../../pages/user/learning-course/ResourceCourseDashboardPage'));
export const CourseRankingsPage = React.lazy(() => import('../../pages/user/learning-course/CourseRankingsPage'));

// Chat and AI pages
export const ChatBot = React.lazy(() => import('../../pages/user/ai/chat/ChatBot'));
export const ChatPurchaseTokensInProducts = React.lazy(() => import('../../pages/user/ai/chat/ChatPurchaseTokensInProducts'));

// Other pages
export const ParentPanelSuccessPage = React.lazy(() => import('../../pages/ParentPanelSuccessPage'));
export const ParentPanelErrorPage = React.lazy(() => import('../../pages/ParentPanelErrorPage'));
